import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "d-flex flex-column"
}
const _hoisted_2 = {
  key: 0,
  class: "top-menu"
}
const _hoisted_3 = { class: "top-menu-container" }
const _hoisted_4 = { class: "brand" }
const _hoisted_5 = {
  key: 0,
  class: "nav-items"
}
const _hoisted_6 = {
  key: 0,
  class: "config-dropdown"
}
const _hoisted_7 = {
  key: 1,
  class: "user-menu"
}
const _hoisted_8 = {
  id: "aligner",
  class: "d-flex"
}
const _hoisted_9 = {
  id: "main-aligner",
  class: "main-content d-flex flex-column align-items-center w-100"
}
const _hoisted_10 = {
  key: 0,
  class: "main-content-card"
}
const _hoisted_11 = {
  key: 2,
  class: "overlay"
}

import { onMounted, ref, computed, nextTick, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { LoadingService } from './services/LoadingService'
import { authService } from './services/backend/authService'
import { ErrorCode } from '../../zabbix-shared/enums/error'
import { IUser } from '../../zabbix-shared/interfaces/intefaces'
import { Icon } from '@iconify/vue'
import UserService from './services/OnlineUserService'
import { isAdmin, isMetroUser } from '../../zabbix-shared/utils/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const user = ref<IUser | null>(null)
const isConfigMenuOpen = ref(false)
const configMenuRef = ref<HTMLElement | null>(null)

const isActive = (basePath: string) => {
  const firstSegment = route.path.split('/')[1]
  return `/${firstSegment}` === basePath
}

const isConfigActive = () => {
  return isActive('/empresas') || isActive('/playbooks') || isActive('/agendamento') || isActive('/usuarios')
}

const isLoading = computed(() => LoadingService.isLoading)

const toggleConfigMenu = () => {
  isConfigMenuOpen.value = !isConfigMenuOpen.value
}

const closeConfigMenu = () => {
  isConfigMenuOpen.value = false
}

const handleClickOutside = (event: MouseEvent) => {
  if (configMenuRef.value && !configMenuRef.value.contains(event.target as Node)) {
    closeConfigMenu()
  }
}

const checkToken = async () => {
  try {
    await authService.getSilentToken()
    user.value = await authService.getLoggedUser();

    UserService.setUser(user.value);
    
    if(route.path == "/auth/login"){
        router.push('/empresas');
    }

    } catch (error: any) {
      const errorCode = error?.response?.data?.error
      if (errorCode === ErrorCode.NOT_AUTHENTICATED) {
        router.push('/auth/login')
      }
    }
  }


const logout = () => {
  authService.logout()
}

onMounted(async () => {
  await checkToken()
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isActive('/auth'))
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Icon), {
                class: "brand-icon",
                icon: "mdi:access-point-network"
              }),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "brand-text" }, "Dashboard", -1))
            ]),
            (user.value)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_5, [
                  (user.value && _unref(isMetroUser)(user.value) || user.value?.company.showMonitoring)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: _normalizeClass(["nav-item", { 'active': isActive('/monitoramento') }]),
                        to: "/monitoramento"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Icon), {
                            icon: "mdi:monitor-dashboard",
                            class: "nav-icon"
                          }),
                          _cache[2] || (_cache[2] = _createTextVNode(" Monitoramento "))
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (user.value && _unref(isMetroUser)(user.value) || user.value?.company.showService)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: _normalizeClass(["nav-item", { 'active': isActive('/atendimento') }]),
                        to: "/atendimento"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Icon), {
                            icon: "mdi:headset",
                            class: "nav-icon"
                          }),
                          _cache[3] || (_cache[3] = _createTextVNode(" Atendimento "))
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["nav-item", { 'active': isActive('/problemas') }]),
                    to: "/problemas"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Icon), {
                        icon: "mdi:alert",
                        class: "nav-icon"
                      }),
                      _cache[4] || (_cache[4] = _createTextVNode(" Problemas "))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createElementVNode("div", {
                    class: "config-menu",
                    onClick: _withModifiers(toggleConfigMenu, ["stop"]),
                    ref_key: "configMenuRef",
                    ref: configMenuRef
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["nav-item config-item", { 'active': isConfigMenuOpen.value || isConfigActive() }])
                    }, [
                      _createVNode(_unref(Icon), {
                        icon: "mdi:cog",
                        class: "config-icon"
                      }),
                      _cache[5] || (_cache[5] = _createTextVNode(" Configurações ")),
                      _createVNode(_unref(Icon), {
                        icon: isConfigMenuOpen.value ? 'mdi:chevron-up' : 'mdi:chevron-down',
                        class: "chevron-icon"
                      }, null, 8, ["icon"])
                    ], 2),
                    (isConfigMenuOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_router_link, {
                            class: _normalizeClass(["config-dropdown-item", { 'active': isActive('/empresas') }]),
                            to: "/empresas",
                            onClick: closeConfigMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Icon), {
                                icon: "mdi:domain",
                                class: "dropdown-icon"
                              }),
                              _createTextVNode(" " + _toDisplayString(_unref(isMetroUser)(user.value) ? 'Empresas' : 'Empresa'), 1)
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          (_unref(isAdmin)(user.value) && _unref(isMetroUser)(user.value))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: _normalizeClass(["config-dropdown-item", { 'active': isActive('/playbooks') }]),
                                to: "/playbooks/compartilhados",
                                onClick: closeConfigMenu
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Icon), {
                                    icon: "mdi:book-open-page-variant",
                                    class: "dropdown-icon"
                                  }),
                                  _cache[6] || (_cache[6] = _createTextVNode(" Playbooks "))
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_unref(isAdmin)(user.value) && _unref(isMetroUser)(user.value))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                class: _normalizeClass(["config-dropdown-item", { 'active': isActive('/agendamento') }]),
                                to: "/agendamentos",
                                onClick: closeConfigMenu
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Icon), {
                                    icon: "mdi:calendar-clock",
                                    class: "dropdown-icon"
                                  }),
                                  _cache[7] || (_cache[7] = _createTextVNode(" Agendamentos "))
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_unref(isAdmin)(user.value))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 2,
                                class: _normalizeClass(["config-dropdown-item", { 'active': isActive('/usuarios') }]),
                                to: "/usuarios",
                                onClick: closeConfigMenu
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Icon), {
                                    icon: "mdi:account-multiple",
                                    class: "dropdown-icon"
                                  }),
                                  _cache[8] || (_cache[8] = _createTextVNode(" Usuários "))
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 512)
                ]))
              : _createCommentVNode("", true),
            (user.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "logout-btn d-flex gap-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (logout()))
                  }, [
                    _cache[9] || (_cache[9] = _createTextVNode(" Sair ")),
                    _createVNode(_unref(Icon), { icon: "mdi:logout" })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("main", null, [
          (_unref(route).path !== '/auth/login')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(), _createBlock(_component_router_view, {
                  key: String(_unref(route).params.groups)
                }))
              ]))
            : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[10] || (_cache[10] = [
                _createElementVNode("div", {
                  class: "spinner-border",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})